import { render, staticRenderFns } from "./AgentReport.vue?vue&type=template&id=a06b223e&scoped=true"
import script from "./AgentReport.vue?vue&type=script&lang=js"
export * from "./AgentReport.vue?vue&type=script&lang=js"
import style0 from "./AgentReport.vue?vue&type=style&index=0&id=a06b223e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b223e",
  null
  
)

export default component.exports